import { render, staticRenderFns } from "./TabelaAgendas.vue?vue&type=template&id=797a0778&scoped=true&"
import script from "./TabelaAgendas.vue?vue&type=script&lang=js&"
export * from "./TabelaAgendas.vue?vue&type=script&lang=js&"
import style0 from "./TabelaAgendas.vue?vue&type=style&index=0&id=797a0778&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797a0778",
  null
  
)

export default component.exports